export class ClusterCentroid {
	constructor(public readonly type: boolean, public readonly values: number[]) {

	}

}
